import React from 'react';

export interface SharedHeadingProps {
  className?: string;
  level?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  alignment?: 'start' | 'center' | 'end';
  visibility?:  boolean;
  children: React.ReactNode;
}

const SharedHeading: React.FC<SharedHeadingProps> = ({
  className = '',
  level = 'h2',
  alignment,
  visibility = true,
  children,
}) => {
  // Don't render if children is falsy (null, undefined, empty string, etc.)
  if (!children) return null;

  const Tag = level;
  const alignClass = alignment ? `attrax-heading--${alignment}` : '';
  const visibilityClass = visibility ? '' : `attrax-heading--hidden`;
  
  return (
    <Tag className={`attrax-heading ${alignClass} ${className} ${visibilityClass}`.trim()}>{children}</Tag>
  );
};

export default SharedHeading;
